import React, { useEffect, useState } from 'react';
import "./Sidebar.css";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useNavigate, Link } from 'react-router-dom'; // Import Link
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

function Sidebar() {
  const [tags, setTags] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTags = async () => {
      const querySnapshot = await getDocs(collection(db, "posts"));
      const allTags = querySnapshot.docs.flatMap(doc => doc.data().tags || []);
      const tagCounts = allTags.reduce((acc, tag) => {
        acc[tag] = (acc[tag] || 0) + 1;
        return acc;
      }, {});
      setTags(Object.entries(tagCounts));
    };

    const fetchRecentPosts = async () => {
      const querySnapshot = await getDocs(collection(db, "posts"));
      const posts = querySnapshot.docs.map(doc => ({
        id: doc.id,
        title: doc.data().title,
        createdAt: doc.data().createdAt
      }));
      const sortedPosts = posts.sort((a, b) => b.createdAt - a.createdAt);
      setRecentPosts(sortedPosts.slice(0, 5)); // Get the 5 most recent posts
    };

    fetchTags();
    fetchRecentPosts();
  }, []);

  // Function to handle tag click
  const handleTagClick = (tag) => {
    navigate(`/tags/${tag}`); // Navigate to /tags/${tag}
  };

  return (
    <div className='sidebar-details'>
      <Card className="mb-3 author-card">
        <h6>Person Behind This Blog</h6>
        <Card.Img variant="top" src="../images/author.jpeg" />
        <Card.Body>
          <Card.Title>Pankaj K. Swami</Card.Title>
          <Card.Text>
            Our Author is Professional Web Developer as Well as Teacher, this Blog is Just to Help students and Spread information
          </Card.Text>
          <Button variant="primary" target='_blank' href="https://www.facebook.com/people/Pankaj-Swami/pfbid0Wp4Zzfuzv362ThJ43gTSBvA1c4PRoSPEi5VR6zJACn6uvDw4MjkyDcnTzL61Dsorl/?mibextid=ZbWKwL">Know More</Button>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Body>
          <Card.Title>Tags</Card.Title>
          <ul className="list-unstyled">
            {tags.map(([tag, count]) => (
              <li key={tag} className="tag-item">
                <button className="btn btn-link" onClick={() => handleTagClick(tag)}>
                  {tag} ({count})
                </button>
              </li>
            ))}
          </ul>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Card.Title>Recent Posts</Card.Title>
          <ul className="list-unstyled">
            {recentPosts.map(post => (
              <li key={post.id} className="recent-post-item">
                <Link to={`/post/${post.id}`}>
                  <span className='recent-post-new'>New:</span> {post.title}
                </Link>
              </li>
            ))}
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Sidebar;
